import type { SubdivisionCatalog } from "./types";

/** Mexico — 31 states plus Ciudad de México. */
export const MEX_SUBDIVISIONS: SubdivisionCatalog = [
  { code: "MX-AGU", name: "Aguascalientes" },
  { code: "MX-BCN", name: "Baja California" },
  { code: "MX-BCS", name: "Baja California Sur" },
  { code: "MX-CAM", name: "Campeche" },
  { code: "MX-CHP", name: "Chiapas" },
  { code: "MX-CHH", name: "Chihuahua" },
  { code: "MX-CMX", name: "Ciudad de México", aliases: ["CDMX", "Distrito Federal", "DF"] },
  { code: "MX-COA", name: "Coahuila de Zaragoza", aliases: ["Coahuila"] },
  // Colima the Mexican state, not Colombia. This is why rows store the full ISO code and not the suffix.
  { code: "MX-COL", name: "Colima" },
  { code: "MX-DUR", name: "Durango" },
  // ISO names it "México", which inside a Mexican address form reads as the country. The list shows
  // "Estado de México"; the submitted value stays the ISO name.
  { code: "MX-MEX", name: "México", displayName: "Estado de México", aliases: ["Edomex"] },
  { code: "MX-GUA", name: "Guanajuato" },
  { code: "MX-GRO", name: "Guerrero" },
  { code: "MX-HID", name: "Hidalgo" },
  { code: "MX-JAL", name: "Jalisco" },
  { code: "MX-MIC", name: "Michoacán de Ocampo", aliases: ["Michoacán"] },
  { code: "MX-MOR", name: "Morelos" },
  { code: "MX-NAY", name: "Nayarit" },
  { code: "MX-NLE", name: "Nuevo León" },
  { code: "MX-OAX", name: "Oaxaca" },
  { code: "MX-PUE", name: "Puebla" },
  { code: "MX-QUE", name: "Querétaro" },
  { code: "MX-ROO", name: "Quintana Roo" },
  { code: "MX-SLP", name: "San Luis Potosí" },
  { code: "MX-SIN", name: "Sinaloa" },
  { code: "MX-SON", name: "Sonora" },
  { code: "MX-TAB", name: "Tabasco" },
  { code: "MX-TAM", name: "Tamaulipas" },
  { code: "MX-TLA", name: "Tlaxcala" },
  { code: "MX-VER", name: "Veracruz de Ignacio de la Llave", aliases: ["Veracruz"] },
  { code: "MX-YUC", name: "Yucatán" },
  { code: "MX-ZAC", name: "Zacatecas" },
];
